import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MODAL_TOKEN, ModalProvider } from '@core';
import { OrIconComponent } from '@ui-components';
import { ProfileOptionAction } from './profile-option-action.enum';

@Component({
  selector: 'lib-profile-options',
  templateUrl: './profile-options.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [OrIconComponent]
})
export class ProfileOptionsComponent {
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);

  sendMessage(): void {
    this.select(ProfileOptionAction.Message);
  }

  reportProfile(): void {
    this.select(ProfileOptionAction.Report);
  }

  private select(action: ProfileOptionAction): void {
    this.modalProvider.dismissModal$(action);
  }
}
